export const GET_INCIDENT_AGING_REQUEST = "GET_INCIDENT_AGING_REQUEST";
export const GET_INCIDENT_AGING_SUCCESS = "GET_INCIDENT_AGING_SUCCESS";
export const GET_INCIDENT_AGING_FAIL = "GET_INCIDENT_AGING_FAIL";

export const GET_INCIDENT_RESOLUTION_REQUEST = "GET_INCIDENT_RESOLUTION_REQUEST";
export const GET_INCIDENT_RESOLUTION_SUCCESS = "GET_INCIDENT_RESOLUTION_SUCCESS";
export const GET_INCIDENT_RESOLUTION_FAIL = "GET_INCIDENT_RESOLUTION_FAIL";

export const GET_INCIDENT_RESOLUTION_SUMMARY_REQUEST = "GET_INCIDENT_RESOLUTION_SUMMARY_REQUEST";
export const GET_INCIDENT_RESOLUTION_SUMMARY_SUCCESS = "GET_INCIDENT_RESOLUTION_SUMMARY_SUCCESS";
export const GET_INCIDENT_RESOLUTION_SUMMARY_FAIL = "GET_INCIDENT_RESOLUTION_SUMMARY_FAIL";

export const GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_REQUEST = "GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_REQUEST";
export const GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_SUCCESS = "GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_SUCCESS";
export const GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_FAIL = "GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_FAIL";

export const GET_INCIDENT_RESOLUTION_PROGRESS_REQUEST = "GET_INCIDENT_RESOLUTION_PROGRESS_REQUEST";
export const GET_INCIDENT_RESOLUTION_PROGRESS_SUCCESS = "GET_INCIDENT_RESOLUTION_PROGRESS_SUCCESS";
export const GET_INCIDENT_RESOLUTION_PROGRESS_FAIL = "GET_INCIDENT_RESOLUTION_PROGRESS_FAIL";

export const TOGGLE_INCIDENT_RESOLUTION_PROGRESS_AVERAGE = "TOGGLE_INCIDENT_RESOLUTION_PROGRESS_AVERAGE"

export const GET_OPEN_INCIDENTS_TREND_REQUEST = "GET_OPEN_INCIDENTS_TREND_REQUEST";
export const GET_OPEN_INCIDENTS_TREND_SUCCESS = "GET_OPEN_INCIDENTS_TREND_SUCCESS";
export const GET_OPEN_INCIDENTS_TREND_FAIL = "GET_OPEN_INCIDENTS_TREND_FAIL";

export const GET_SLA_FILTER_LOOKUPS_REQUEST = "GET_SLA_FILTER_LOOKUPS_REQUEST";
export const GET_SLA_FILTER_LOOKUPS_SUCCESS = "GET_SLA_FILTER_LOOKUPS_SUCCESS";
export const GET_SLA_FILTER_LOOKUPS_FAIL = "GET_SLA_FILTER_LOOKUPS_FAIL";

export const GET_SLA_DATA_SUMMARY_REQUEST = "GET_SLA_DATA_SUMMARY_REQUEST";
export const GET_SLA_DATA_SUMMARY_SUCCESS = "GET_SLA_DATA_SUMMARY_SUCCESS";
export const GET_SLA_DATA_SUMMARY_FAIL = "GET_SLA_DATA_SUMMARY_FAIL";